<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>员工中心</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="isHideDetails = false">问题反馈</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!isHideDetails">
      <section class="searchBox">
        <!-- <span>
          <a-button
            v-show="!showIsSearch"
            @click="showIsSearch = true"
          >显示更多</a-button>
          <a-button
            v-show="showIsSearch"
            @click="showIsSearch = false"
          >隐藏更多</a-button>
        </span>
        <span v-show="showIsSearch">
          <label>一级项目：</label>
          <a-select
            showSearch
            :filterOption="filterOption"
            v-model="selectedOneVal"
            @change="selectedOne"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListOne"
              :key="i"
            >{{ item.project_name }}</a-select-option>
          </a-select>
        </span>
        <span v-show="isShowTwo && showIsSearch">
          <label>省级项目：</label>
          <a-select
            v-model="selectedTwoVal"
            @change="selectedTwo"
            showSearch
            :filterOption="filterOption"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListTwo"
              :key="i"
            >{{ item.project_name }}</a-select-option>
          </a-select>
        </span>
        <span>
          <label>项目：</label>
          <a-select
            v-model="selectedThreeVal"
            showSearch
            :filterOption="filterOption"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListThree"
              :key="i"
            >{{ item.project_name }}</a-select-option>
          </a-select>
        </span> -->
        <span>
          <label>提交时间：</label>
          <a-range-picker
            :placeholder="['开始时间', '结束时间']"
            @change="onChangeDate"
            v-model="date"
            style="margin-right:20px"
          />
        </span>
        <span>
          <label>字符串：</label>
          <a-input
            v-model="nameSearch"
            placeholder="请输入用户名|手机号"
            style="width:180px;"
          />
        </span>
        <span>
          <a-button style="margin-right:10px" @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.project_names }}</td>
              <td>{{ item.create_time.substring(0, 10) }}</td>
              <td>{{ item.user_name }}</td>
              <td>{{ item.phone }}</td>
              <td style="width:40%">{{ item.content }}</td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 详情 -->
    <!-- <resumeDetail v-show="isHideDetails" :details="details" /> -->
    <!-- 详情 end-->
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
// import resumeDetail from "@/components/resume/resumeDetail.vue";
export default {
  components: {
    // resumeDetail
  },
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      hideInAddMap: false,
      query_field: "",
      hideInUserEdit: false,
      editDetail: {},
      totalPage: Number,
      nameSearch: "",
      thList: ["项目", "日期", "姓名", "手机号码", "内容"],
      hideInAddMapOne: false,
      isHideDetails: false,
      details: {},
      start_date: "",
      end_date: "",
      date: null,
      proListOne: [],
      proListTwo: [],
      proListThree: [],
      isShowTwo: false,
      selectedOneVal: "",
      selectedTwoVal: "",
      selectedThreeVal: "",
      showIsSearch: false
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
  },
  methods: {
    onChangeDate(date, dateString) {
      this.start_date = dateString[0];
      this.end_date = dateString[1];
      //  console.log(this.searchDate);
    },
    detailPage(val) {
      // this.$router.push({name:"resumeDetails"})
      this.details = val;
      this.isHideDetails = true;
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },

    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
      // console.log(value);
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url + this.httpsBasic.user + "User/adminFeedbackList";
      let params = {
        current_page: this.page,
        per_page: 10,
        query_field: this.nameSearch,
        token: window.localStorage.getItem("xnwfPcToken"),
        start_date: this.start_date,
        end_date: this.end_date
      };
      if (this.start_date == "" || this.start_date == undefined) {
        delete params.start_date;
      }
      if (this.end_date == "" || this.end_date == undefined) {
        delete params.end_date;
      }
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(res);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    onReset() {
      this.date = undefined;
      this.start_date = "";
      this.end_date = "";
      this.nameSearch = "";
      this.page = 1;
      this.getData();
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .searchBox {
    padding: 14px 2%;
    display: block;
    > span {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
      button {
        margin-left: 10px;
      }
    }
  }
  .changeTask {
    img {
      height: 16px;
    }
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
